//import axios from 'axios';
import React, { useEffect, useState } from 'react';
// import {useSelector} from 'react-redux';
// import {selectLoaded} from '../../store/reducers/storage';
import {  getMarketNftsLiveById } from '../../utils/wallet';
import { useGLTF , Stage} from "@react-three/drei";
import { Canvas } from '@react-three/fiber';
import {  PresentationControls, Environment, ContactShadows } from '@react-three/drei';

import { Suspense } from "react";
import LoaderGlb from '../loaderGlb/LoaderGlb';

const Model = (glbPath) => {
    console.log(glbPath.glbPath)
    const { scene } = useGLTF(glbPath.glbPath);
    return <primitive object={scene} />;
}

// const Card = (props) => {
//     // const { item } = props;
//     //console.log(props);

//     // const name = props.itemData.name;
//     const description = props.itemData.description;
//     const glbPath = props.itemData.glbPath;
//     //const url = '/tim.jpg';

//     // const { name, description, glbPath } = props;
//     console.log('description', description);
//     console.log('glbPath', glbPath);

//     return (


//         <div className="container">
//             <div className="row">
//                 <div className="col-lg-12 align-self-center">
//                     <div className="row">


//                         <div className="col">
//                             <div className="card h-600">
//                                 {/* <img src={props.img} className="card-img-top" alt="..." /> */}
//                                 {/* <Canvas pixelRatio={[1, 2]} camera={{ position: [-1, 1, 1], fov: 50 }}>
//                             <ambientLight intensity={1} />
//                                 <Suspense fallback={null}>
//                                     <Model glbPath={glbPath}/>
//                                 </Suspense>
//                             <OrbitControls />
//                         </Canvas> */}



//                                 <Canvas style={{ height: '950px' }}>

//                                     <ambientLight intensity={0.9} />

//                                     <Suspense fallback={null}>
//                                         <Stage preset="rembrandt" intensity={1} environment="city">
//                                             <Model glbPath={'./PlayerNFT.glb'} />
//                                         </Stage>
//                                     </Suspense>

//                                     <OrbitControls />
//                                 </Canvas>

//                                 {/* <div className="card-body">
//                         <h5 className="card-title">{name}</h5>
//                         <p className="card-text">{description}</p>
                        
//                     </div> */}

//                             </div>
//                         </div>
//                     </div>
//                 </div>



//             </div>
//         </div>
//     );
// };

const Account = () => {
    const itemId = 0;
    const [loading, setLoading] = useState(true);
    const [item, setItem] = useState({
        name: 'Loading...',
        description: 'Loading...',
        glbPath: '',
        url: ''
    });

    useEffect(() => {
        try {
            const func = async () => {
                const props = await getMarketNftsLiveById(itemId);
                console.log(props);
                setItem(props);
                setLoading(false);
            }
            func();
        } catch (err) {
            console.log(err);
        }
        
    }, [itemId]);

    useEffect(() => {
        const func = async () => {
           try {
            //let tokens = [];
            //const playerNfts = await getUserPlayerNfts();
            //console.log(playerNfts)
            // for (let i = 0; i < playerNfts.length; i++) {
            //     if (playerNfts[i].url) {
            //         let token = {};
            //         token.token_id = playerNfts[i].token_id;
            //         const response = await axios.get('https://ipfs.io/ipfs/' + playerNfts[i].url);
            //         let data = response.data;
            //         console.log('data', data);
            //         token.name = data.name;
            //         token.description = data.description;
            //         if (data.displayUri) token.img = 'https://ipfs.io/ipfs/' + data.displayUri.slice(7);
            //         tokens.push(token);
            //     }
            // }
            //setNfts(tokens);
            //console.log('storage set!');
                setLoading(false);
            } catch (err) {
                console.log(err);
                setLoading(false);
            }
        };


        func();


        // eslint-disable-next-line
    }, []);// [setNfts]);

    console.log(item);

    return (
        <div>
            <div className="row row-cols-1 row-cols-md-3 g-4" style={{ background: 'black' }}>
                {loading ? <div style={{ width: '100%', height: '2000px', background: 'transparent' }}>
                    <div className='centerLoader'>
                        <span className="spinner-border spinner-border-lg" role="status" aria-hidden="true"></span>
                    </div>
                </div>
                    : <>
                      <div className="col-md-8 offset-md-2" style={{background:'transparent', marginTop:"180px"}}>
                    
                    {/* <Card itemData={item} /> */}

                        <div className="col">
                            <div className="card" style={{height: '80vh',width: '100%'}}>
                                <Canvas shadows dpr={[1, 2]} camera={{ position: [0, 0, 1], fov: 50 }}>
                                <Suspense fallback={<LoaderGlb />}>
                                    <ambientLight intensity={0.5} />
                                    <spotLight position={[10, 10, 10]} angle={0.15} penumbra={1} shadow-mapSize={[512, 512]} castShadow />
                                    <PresentationControls
                                        global
                                        config={{ mass: 2, tension: 500 }}
                                        snap={{ mass: 4, tension: 1500 }}
                                        rotation={[0, 0.3, 0]}
                                        polar={[-Math.PI / 3, Math.PI / 3]}
                                        azimuth={[-Math.PI / 1.4, Math.PI / 2]}>
                                            <Stage preset="rembrandt" intensity={1} environment="city">
                                        
                                        <Model glbPath={'./PlayerNFT.glb'} />
                                    
                                        </Stage>
                                    </PresentationControls>
                                    <ContactShadows rotation-x={Math.PI / 2} position={[0, -1.4, 0]} opacity={0.75} width={10} height={10} blur={2.6} far={2} />
                                    <Environment preset="city" />
                                    </Suspense>
                                </Canvas>
                                {/* <div className="card-body">
                                    <h5 className="card-title">{item.name}</h5>
                                    <p className="card-text">{item.description}</p>  
                                </div> */}
                            </div>
                        </div>
                    
                    </div>
                        {/* <div className="row row-cols-1 row-cols-md-3 g-4" style={{ background: 'black', marginTop: '260px', width: '100%' }}>
                           
                            <div className="container">
                            <div className="row">
                                <div className="col-lg-12 align-self-center">
                                    <div className="row">


                        <div className="col">
                            <div className="card h-600"></div>
                            <Canvas shadows dpr={[1, 2]} camera={{ position: [0, 0, 1], fov: 50 }}>
                                <Suspense fallback={null}>
                                    <ambientLight intensity={0.5} />
                                    <spotLight position={[10, 10, 10]} angle={0.15} penumbra={1} shadow-mapSize={[512, 512]} castShadow />
                                    <PresentationControls
                                        global
                                        config={{ mass: 2, tension: 500 }}
                                        snap={{ mass: 4, tension: 1500 }}
                                        rotation={[0, 0.3, 0]}
                                        polar={[-Math.PI / 3, Math.PI / 3]}
                                        azimuth={[-Math.PI / 1.4, Math.PI / 2]}>
                                        <Stage preset="rembrandt" intensity={1} environment="city">
                                        
                                             <Model glbPath={'./PlayerNFT.glb'}/>
                                    
                                        </Stage>
                                    </PresentationControls>
                                    <ContactShadows rotation-x={Math.PI / 2} position={[0, -1.4, 0]} opacity={0.75} width={10} height={10} blur={2.6} far={2} />
                                    <Environment preset="city" />
                                    </Suspense>
                                </Canvas>
                        </div>
                        </div>
                        </div>
                        </div>

                        </div>
                        </div> */}
                    </>
                    }
            </div>
        </div>
    );
};

export default Account;
